import React, {Component} from 'react';


class AppBreadcrumbs extends Component {

    render() {
        let filtersOptions = [];
        let filtersOptionsValues = [];
        const localStorageValues = ["breinwaarde", "duur-les", "didactisch-principe", "duur-voorbereiding", "aantal-studenten", "kennis-of-vaardigheidsvak"];
        //voor elke waarde...
        localStorageValues.forEach(function(localStorageValue){
            if(localStorage.getItem(localStorageValue) !== null){
                localStorage.getItem(localStorageValue).split("&").slice(0, -1).forEach(() => {
                    filtersOptionsValues.push(localStorageValue);
                });
                filtersOptions = filtersOptions.concat(localStorage.getItem(localStorageValue).split("&").slice(0, -1));
            }
        })


        function arrayRemove(arr, value) {
            return arr.filter(function(ele){
                return ele !== value;
            });
         }

        function clickBreadcrumb(storageValue, filterOption){
            const localArray = localStorage.getItem(storageValue).split("&").slice(0, -1);
            const adjustedLocalArray = arrayRemove(localArray, filterOption);
            let result = "";
            adjustedLocalArray.forEach(el => {
                result+=(el+'&');
            });
            localStorage.setItem(storageValue, result);
            window.location.reload();
        }

        const filterOptionList = filtersOptions.map((filterOption, index) =>
            <li key={filterOption} onClick={clickBreadcrumb.bind(this, filtersOptionsValues[index], filterOption)} localvalue={filtersOptionsValues[index]}>
                <div>
                    <div>
                        <p>{filterOption}</p>&nbsp;&nbsp;<img src="img/kruisje-icoon-roze_2x.png" height="9px" alt="Kruisje" />
                    </div>
                </div>
            </li>
        ) 
        if(filtersOptions.length >= 1){
            return(
                <section className="filtermenu">
                    <ul>
                        {filterOptionList}
                    </ul>
                </section>
            )
        }else{
            return(
                <span></span>
            )
        }
    }
};

export default AppBreadcrumbs;

